import React, { PureComponent } from 'react';
import styled from 'styled-components';
import {ICONS} from '../data/constants';
import IconComponent from '../components/IconComponent';

export interface Props {
  isPlaying: boolean;
  customColors?: any;
  onPlayPause?: (...args: any[]) => void;
}
export default class PlayPauseButtonComponent extends PureComponent<Props, any> {
  constructor(props: Props) {
    super(props);

    this.state = {
        hascolors: this.props.customColors.length > 0 ? true : false
    };
  }

  render() {
    return (
      <PlayPauseButton onClick={this.props.onPlayPause} className="playPause-button" customColors={this.state.hascolors ? this.props.customColors : []}>
        <IconComponent
          className={this.props.isPlaying ? "playing" : "paused"}
          icon={this.props.isPlaying ? ICONS.PAUSE : ICONS.PLAY}
          color={'#fff'}
          size={22}
        />
      </PlayPauseButton>
    );
  }
}

const PlayPauseButton: any = styled.span`
  position: absolute;
  left: 10px;
  top: 9px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1px solid ${(props: any) => props.customColors.length > 0 ? props.customColors[4] : '#ffcb2e'};
  background-color: rgba(0,0,0,0.5);
  [class*="icon"] {
    width: 42px;
    height: 42px;
    opacity: 1;
  }
  svg {
    font-size: 22px;
    position: absolute;
    top: 10px;
    left: 15px;
    path {
      fill: ${(props: any) => props.customColors.length > 0 ? props.customColors[4] : '#ffcb2e'};
    }
  }
  &:hover {
    cursor: pointer;
  }
  a {
    display: block;
  }
  .playing {
    left: 12px;
    font-size: 22px;
    top: 10px;
  }
`;
